
export default class {

    constructor() 
    {
        this.close = document.getElementById('panel-advance-search-station-option');
        this.close.addEventListener('click',this,false);
    }
    
    handleEvent(evt)
    {
        let target =  evt.target;

        let panel =  document.getElementById('panel-advance-search-station');

        panel.classList.toggle('d-none');

    }


}
